/**
 * 全局 loading：按请求计数（并发安全），延迟点亮避免快请求一闪而过；
 * 点亮后保证最短展示时长，避免刚显示就熄灭造成闪烁。
 * API 拦截器在请求发出/结束时 begin/end；AppLoading.vue 读取 visible 渲染遮罩。
 */
const SHOW_DELAY_MS = 280
const MIN_VISIBLE_MS = 1000

let showTimer: ReturnType<typeof setTimeout> | null = null
let hideTimer: ReturnType<typeof setTimeout> | null = null
let shownAt = 0

export function useGlobalLoading() {
  const count = useState<number>('app-global-loading-count', () => 0)
  const visible = useState<boolean>('app-global-loading-visible', () => false)

  const begin = () => {
    if (!import.meta.client) return
    count.value++
    // 取消尚未执行的隐藏（隐藏等待期来了新请求时保持显示）
    if (hideTimer) {
      clearTimeout(hideTimer)
      hideTimer = null
    }
    if (!showTimer && !visible.value) {
      showTimer = setTimeout(() => {
        showTimer = null
        if (count.value > 0) {
          visible.value = true
          shownAt = Date.now()
        }
      }, SHOW_DELAY_MS)
    }
  }

  const end = () => {
    if (!import.meta.client) return
    count.value = Math.max(0, count.value - 1)
    if (count.value > 0) return
    if (showTimer) {
      clearTimeout(showTimer)
      showTimer = null
    }
    if (!visible.value) return
    // 最短展示：点亮不足 MIN_VISIBLE_MS 时等满再熄
    const wait = Math.max(0, MIN_VISIBLE_MS - (Date.now() - shownAt))
    if (hideTimer) clearTimeout(hideTimer)
    hideTimer = setTimeout(() => {
      hideTimer = null
      if (count.value === 0) visible.value = false
    }, wait)
  }

  return { visible, begin, end }
}
